enum JobActivityCategory {
  INFO = 10,
  WARRANTY = 20,
  ORDER = 30,
  PRICE = 40,
  COMMENT = 50,
  MEDIA = 60,
  TAGS = 70,
}

export default JobActivityCategory;